import { render, staticRenderFns } from "./question-and-answer-grid.vue?vue&type=template&id=c57814c4&scoped=true&"
import script from "./question-and-answer-grid.vue?vue&type=script&lang=js&"
export * from "./question-and-answer-grid.vue?vue&type=script&lang=js&"
import style0 from "./question-and-answer-grid.vue?vue&type=style&index=0&id=c57814c4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57814c4",
  null
  
)

export default component.exports